import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeBtn.svg"

import { useTranslate } from '@tolgee/react';

import ForwardModalChatElement from './ForwardModalChatElement';
import { cloneDeep } from 'lodash';
import ForwardModalContactElement from './ForwardModalContactEmelement';
import { filterContacts } from '../../Helpers/filters/filterContacts';
import { filterConversations } from '../../Helpers/filters/filterConversations';
import { useConversationService } from '../../Context/ConversationsContext';

import moment from 'moment';
import FileAttachmentItem from './FileAttachmentItem';
import { MediaPlayer, MediaProvider } from '@vidstack/react';
import { DefaultVideoLayout, defaultLayoutIcons } from '@vidstack/react/player/layouts/default';
import { useAuthService } from '../../Context/AuthContext';
import { findTranslatedTextForUser } from '../../Helpers/chatHelper/ChatHelper';
import SearchMenu from '../GenericComponents/SearchMenu';
import { useNotify } from '../../Helpers/Notifications';
import PrimaryButton from '../GenericComponents/PrimaryButton';

const ForwardModal = ({ handleClose, chats, contextMenuItem }) => {
    const { t } = useTranslate();
    const { forwardMessage, getContactsOnPlatformForCurrentUser } = useConversationService()
    const { user } = useAuthService();
    const [searchValue, setSearchValue] = useState("");
    const [selectedConversations, setSelectedConversations] = useState([]);
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [contacts, setContacts] = useState(null);
    const { image, original_message, video, message_translations } = contextMenuItem.messageObject;
    const { notifySuccess, notifyError, notifyInfo } = useNotify();
    const handleGetContactsForCurrentUser = () => {
        getContactsOnPlatformForCurrentUser(
            (response) => {
                const contacts = response.data.contacts
                setContacts(contacts)
            },
            (error) => {
                notifyError(`${t('general.something_wrong')}`);

            }
        )
    }

    const file = contextMenuItem.messageObject.document


    const handleConversationSelect = (element) => {
        let clone = cloneDeep(selectedConversations);
        let found = selectedConversations?.find((item) => item.id == element.id)
        if (found) {
            let filtered = clone.filter((item) => item.id !== element.id);
            setSelectedConversations(filtered)
        } else {
            clone.push(element);
            setSelectedConversations(clone)
        }
    }

    const handleContactSelect = (element) => {
        let clone = cloneDeep(selectedContacts);
        let found = selectedContacts?.find((item) => item.id == element.id)
        if (found) {
            let filtered = clone.filter((item) => item.id !== element.id);
            setSelectedContacts(filtered)
        } else {
            clone.push(element);
            setSelectedContacts(clone)
        }
    }

    const displaySelectionNumber = () => {
        let selection = selectedConversations.length + selectedContacts.length;

        if (selection == 0) {
            return ""
        }

        if (selection === 1) {
            return `${selection + " chat"}`
        }

        if (selection > 1) {
            return `${selection + " chats"}`
        }
    }

    const handleForwardmessage = () => {
        let phoneNumbers = [];
        let emails = [];
        let conversationIds = selectedConversations.map((item) => { return (item.id) });

        selectedContacts.forEach((item) => {
            if (item.phone_number) {
                phoneNumbers.push(item.phone_number)
            }
            if (item.email) {
                emails.push(item.email)
            }
        })

        let nowDate = moment().toISOString();
        forwardMessage(
            conversationIds,
            phoneNumbers,
            emails,
            nowDate,
            contextMenuItem.messageId,
            (response) => {
                handleClose();
            },
            (error) => {
                notifyError(t('general.something_wrong'))
            },


        )
    }

    useEffect(() => {
        const keyDownHandler = event => {
            if (event.key === 'Escape') {
                event.preventDefault();
                // 👇️ your logic here
                handleClose();
            }
        };

        document.addEventListener('keydown', keyDownHandler);

        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };
    }, []);

    function auto_grow(element) {
        element.style.height = "5px";
        element.style.height = element.scrollHeight + "px";
    }

    useEffect(() => {
        if (original_message) {
            let element = document.getElementById("resizeTa-3");
            if (element) {
                auto_grow(element)
            }
        }

    }, [original_message])

    useEffect(() => {
        handleGetContactsForCurrentUser()
    }, [])

    return (
        <FullScreenContainer>
            <Card>
                <Header>

                    <Text>
                        <h1>{t('chat.forward_to')}</h1>
                    </Text>
                    <CloseBtn onClick={handleClose}>
                        <CloseIcon />
                    </CloseBtn>
                </Header>

                <Content>
                    <Group>
                        <h2>{t('chat.forward_message')}</h2>
                        {image &&
                            <ImgWrapper>
                                <img src={image.url} alt='pht' />
                            </ImgWrapper>
                        }
                        {video &&
                            <VideoPreview>
                                <MediaPlayer
                                    load='visible'
                                    posterLoad='visible'
                                    controls
                                    playsInline
                                    src={video.video_url}
                                >
                                    <MediaProvider />
                                    <DefaultVideoLayout thumbnails={video.thumbnail.url} icons={defaultLayoutIcons} />
                                </MediaPlayer>
                            </VideoPreview>
                        }

                        {file &&
                            <FileAttachmentItem
                                file={file}
                            />
                        }

                        {original_message.length > 0 &&
                            <>
                                <CustomTextArea
                                    id='resizeTa-3'
                                    value={findTranslatedTextForUser((message_translations), user).translation}
                                    readOnly />
                            </>
                        }


                    </Group>
                    <SearchMenu
                        placeholder={(t('general.search'))}
                        setvalue={(e) => setSearchValue(e)}
                        value={searchValue}
                    />

                    {filterConversations(chats, searchValue)?.length > 0 &&
                        <Group>
                            <h2>{t('general.chats')}</h2>
                            <ContactsWrapper>
                                {filterConversations(chats, searchValue)?.map((item, index) => (
                                    <ForwardModalChatElement
                                        key={item.id}
                                        data={item}
                                        handleContactSelect={handleConversationSelect}
                                        selected={selectedConversations.find((element) => element.id === item.id)}
                                    />
                                ))}
                            </ContactsWrapper>
                        </Group>
                    }

                    {filterContacts(contacts, searchValue)?.length > 0 &&
                        <Group>
                            <h2>{t('general.contacts')}</h2>
                            <ContactsWrapper>
                                {filterContacts(contacts, searchValue)?.map((item, index) => (
                                    <ForwardModalContactElement
                                        key={item.id}
                                        item={item}
                                        handleSelectContact={handleContactSelect}
                                        selected={selectedContacts.find((element) => element.id === item.id)}
                                    />

                                ))}
                            </ContactsWrapper>
                        </Group>
                    }

                </Content>

                <Bottom>
                    <ChatNumberWrapper>
                        <p>{displaySelectionNumber()} </p>
                    </ChatNumberWrapper>
                    {selectedContacts.concat(selectedConversations).length > 0 &&
                        <PrimaryButton
                            onClick={() => handleForwardmessage()}
                        >
                            {t('chat.forward')}
                        </PrimaryButton>}


                </Bottom>

            </Card>

        </FullScreenContainer>
    )
}

export default ForwardModal

const FullScreenContainer = styled.div`
display:flex;
align-items:center;
justify-content:center;
position:fixed;
width:100%;
height:100%;
background:rgba(0,0,0,0.3);
left:0;
top:0;
padding:5vh 40vw;
`
const Card = styled.div`
display:flex;
flex-direction:column;
gap:24px;
padding:25px 20px;
background:${({ theme }) => theme.menu.background};
width:100%;
height:100%;
min-width:600px;
border-radius:4px;
`
const Group = styled.div`
display:flex;
flex-direction:column;
gap:10px;
h2{
font-size: 14px;
font-weight: 500;
line-height: 22px;
letter-spacing: -0.40799999237060547px;
text-align: left;
color:${({ theme }) => theme.menu.secondaryTextColor};
text-transform:uppercase;
}
`
const Header = styled.div`
display:flex;
justify-content:center;
position:relative;
`
const CloseBtn = styled.button`
display:flex;
align-items:center;
justify-content:center;
border:none;
background:none;
cursor:pointer;
position:absolute;
right:0;
top:1px;
svg{
height:28px;
color:${({ theme }) => theme.menu.selectedOpionBackground};
stroke:${({ theme }) => theme.sidebar.borderColor};
}
`
const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: px;
overflow:hidden;
h1{
  text-transform:capitalize;
color:${({ theme }) => theme.menu.primaryTextColor};
font-size: 20px;
font-weight: 500;
line-height: 30px;
text-align: left;

}
`;
const Content = styled.div`
display:flex;
flex-direction:column;
height:100%;
overflow:auto;
gap:20px;
`
const Bottom = styled.div`
padding-top:25px;
display:flex;
justify-content:space-between;
border-top:1px solid ${({ theme }) => theme.sidebar.borderColor};
margin-top:auto;
`
const ChatNumberWrapper = styled.div`
display:flex;
align-items:center;
p{
font-size: 16px;
font-weight: 400;
line-height: 22px;
letter-spacing: -0.40799999237060547px;
text-align: left;
color:${({ theme }) => theme.menu.primaryTextColor};
}
`
const ForwardBtn = styled.button`
font-size: 16px;
font-weight: 600;
line-height: 22px;
text-align: left;
color:${({ theme }) => theme.primaryButton.color};
border:none;
background:none;
cursor:pointer;

`
const CustomTextArea = styled.textarea`
background:${({ theme }) => theme.menu.groupContentBackground};
border-radius:4px;
resize:none;
max-height:160px;
outline:none;
border:none;
padding:10px;
color:${({ theme }) => theme.menu.primaryTextColor};
font-size: 14px;
font-weight: 400;
line-height: 17px;
letter-spacing: 0px;
text-align: left;
`

const ContactsWrapper = styled.div`
background:${({ theme }) => theme.menu.groupContentBackground};
display: flex;
flex-direction: column;
border-radius:4px;
padding: 10px 16px;
gap: 8px;
`

const ImgWrapper = styled.div`
img{
    overflow:hidden;
        cursor:pointer;
width:100%;
    }
`

const VideoPreview = styled.div`
display:flex;
height:100%;
width:100%;

justify-content:center;
align-items:center;
position:relative;
overflow:hidden;
`
